import { memo, useEffect, useState } from 'react';
import spinnerCircle from '../../images/icons/spinnerCircle.svg';
import spinnerIcon from '../../images/icons/spinnerIcon.svg';
import { useTranslation } from 'react-i18next';
import { Modal } from 'react-bootstrap';
import './CustomSpinner.scss';

export interface SpinnerOptions {
    isFullScreen?: boolean;
    hideTextTitle?: boolean;
    sizeRem?: number;
}

const CustomSpinner: React.FC<SpinnerOptions> = memo((props) => {
    const { isFullScreen, hideTextTitle, sizeRem } = props;
    const { t } = useTranslation();

    const SpinnerBody = () => {
        return (
            <div className="custom-spinner">
                <div className="spinner-container" 
                    style={{ height: `${sizeRem ? sizeRem : ''}rem`, width: `${sizeRem ? sizeRem : ''}rem` }}>
                    <img className="rotate-circle" alt="" src={spinnerCircle} />
                    <img className="spinner-icon" alt="Spinner Icon" src={spinnerIcon} />
                </div>
                {hideTextTitle ? undefined : <div className="spinner-text">{t('spinner.status')}</div>}
            </div>
        );
    };

    const ModalSpinner = () => {
        const [show, setShow] = useState(true);

        useEffect(() => {
            document.body.setAttribute('aria-busy', 'true');
            return () => {
                document.body.setAttribute('aria-busy', 'false');
            };
        }, [show]);

        const toggle = () => {
            setShow(!show);
            document.body.setAttribute('aria-busy', 'false');
        };
        return (
            <Modal className="custop-spinner-modal" show={show} onHide={toggle} backdrop="static" centered>
                <Modal.Body>
                    <SpinnerBody />
                </Modal.Body>
            </Modal>
        );
    };

    if (isFullScreen) {
        return <ModalSpinner />;
    } else {
        return <SpinnerBody />;
    }
});

CustomSpinner.displayName = "CustomSpinner";

export default CustomSpinner;
